<app-steps [current]="stepAtual()" [total]="totalSteps()"></app-steps>
<h2 class="title">Beneficiários</h2>

<form [formGroup]="form">
  @for (grupo of grupos; track grupo.chave) {
    <section class="grupo" [attr.aria-labelledby]="'titulo-' + grupo.chave">
      <h3 class="grupo__titulo" [id]="'titulo-' + grupo.chave">{{ grupo.titulo }}</h3>
      <p class="grupo__descricao">{{ grupo.descricao }}</p>

      <!-- No celular a tabela rola na horizontal em vez de espremer os campos. -->
      <div class="tabela-rolagem">
        <table class="tabela" [formArrayName]="grupo.chave">
          <colgroup>
            <col class="tabela__col-nome" />
            <col class="tabela__col-cpf" />
            <col class="tabela__col-data" />
            <col class="tabela__col-parentesco" />
            <col class="tabela__col-percentual" />
            <col class="tabela__col-acoes" />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">Nome</th>
              <th scope="col">CPF</th>
              <th scope="col">Data de nascimento</th>
              <th scope="col">Parentesco</th>
              <th scope="col">Percentual</th>
              <th scope="col" class="tabela__acoes">Ações</th>
            </tr>
          </thead>
          <tbody>
            @for (linha of linhas(grupo.chave).controls; track linha; let i = $index) {
              <tr [formGroupName]="i">
                <td>
                  <vivest-input
                    formControlName="nome"
                    label=""
                    [attr.aria-label]="'Nome do ' + grupo.rotulo + ' ' + (i + 1)"
                    placeholder="Nome completo"
                    name="nome"
                    type="text"
                    [vivestMaxLength]="100"
                    [status]="status(grupo.chave, i, 'nome')"
                  ></vivest-input>
                </td>
                <td>
                  <vivest-input
                    formControlName="cpf"
                    vivestFormat="cpf"
                    label=""
                    [attr.aria-label]="'CPF do ' + grupo.rotulo + ' ' + (i + 1)"
                    placeholder="000.000.000-00"
                    name="cpf"
                    type="text"
                    [status]="status(grupo.chave, i, 'cpf')"
                  ></vivest-input>
                </td>
                <td>
                  <!-- A data pode ser digitada ou escolhida no calendário do navegador, aberto pelo ícone. -->
                  <div class="campo-data">
                    <vivest-input
                      formControlName="dataNascimento"
                      vivestFormat="data"
                      label=""
                      [attr.aria-label]="'Data de nascimento do ' + grupo.rotulo + ' ' + (i + 1)"
                      placeholder="dd/mm/aaaa"
                      name="dataNascimento"
                      type="text"
                      icon="calendar"
                      [status]="status(grupo.chave, i, 'dataNascimento')"
                    ></vivest-input>
                    <input
                      class="campo-data__calendario"
                      type="date"
                      [max]="hoje"
                      [value]="dataDoCalendario(grupo.chave, i)"
                      [attr.aria-label]="'Abrir calendário da data de nascimento do ' + grupo.rotulo + ' ' + (i + 1)"
                      (change)="escolherData(grupo.chave, i, $event)"
                    />
                  </div>
                </td>
                <td>
                  <vivest-select
                    formControlName="parentesco"
                    label=""
                    [attr.aria-label]="'Parentesco do ' + grupo.rotulo + ' ' + (i + 1)"
                    placeholder="Selecione"
                    [options]="parentescoOptions()"
                    [status]="status(grupo.chave, i, 'parentesco')"
                  ></vivest-select>
                </td>
                <td>
                  <vivest-input
                    formControlName="percentual"
                    vivestFormat="digits"
                    [vivestMaxLength]="3"
                    label=""
                    [attr.aria-label]="'Percentual do ' + grupo.rotulo + ' ' + (i + 1)"
                    placeholder="0"
                    name="percentual"
                    type="text"
                    icon="percent"
                    [status]="status(grupo.chave, i, 'percentual')"
                  ></vivest-input>
                </td>
                <td class="tabela__acoes">
                  <vivest-icon-button
                    variant="outline"
                    size="sm"
                    icon="trash-2"
                    [attr.aria-label]="'Remover ' + grupo.rotulo + ' ' + (i + 1)"
                    (click)="remover(grupo.chave, i)"
                  ></vivest-icon-button>
                </td>
              </tr>
            } @empty {
              <tr>
                <td class="tabela__vazia" colspan="6">Nenhum beneficiário adicionado.</td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <div class="grupo__rodape">
        <vivest-button variant="outline" size="sm" (click)="adicionar(grupo.chave)">
          <vivest-icon slot="icon-left" name="plus" source="feather"></vivest-icon>
          {{ grupo.botaoAdicionar }}
        </vivest-button>

        <!-- A regra vale para os dois grupos juntos: os dois totais ficam vermelhos e o aviso aparece uma vez, no último. -->
        <div class="total" [class.total--invalido]="!totalGeralValido()">
          <p class="total__valor" aria-live="polite">
            Total: <span class="total__numero">{{ total(grupo.chave) }}%</span>
          </p>
          @if (!totalGeralValido() && $last) {
            <p class="total__aviso">
              A soma dos percentuais dos beneficiários preferenciais e designados deve ser {{ percentualTotal }}%.
            </p>
          }
        </div>
      </div>
    </section>
  }

  <div class="d-flex justify-content-center align-items-center buttons-requerimento">
    <vivest-button variant="outline" size="md" (click)="onReturn()">
      Voltar
    </vivest-button>
    <vivest-button
      variant="primary"
      size="md"
      [disabled]="!podeContinuar() || salvando()"
      (click)="onSubmit()"
    >
      <vivest-icon slot="icon-right" name="arrow-right" source="feather"></vivest-icon>
      Continuar para Documentos
    </vivest-button>
  </div>
</form>
